/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sport: NonNullable<unknown>, date: NonNullable<unknown> }} Ui_Session_Delete_DescInputs */

const en_ui_session_delete_desc = /** @type {(inputs: Ui_Session_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete the ${i?.sport} session from ${i?.date}? This action cannot be undone.`)
};

const de_ui_session_delete_desc = /** @type {(inputs: Ui_Session_Delete_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bist du sicher, dass du die ${i?.sport}-Einheit vom ${i?.date} löschen möchtest? Diese Aktion lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete the {sport} session from {date}? This action cannot be undone." |
*
* @param {Ui_Session_Delete_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_delete_desc = /** @type {((inputs: Ui_Session_Delete_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_Delete_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_delete_desc(inputs)
	return de_ui_session_delete_desc(inputs)
});